module.exports = __webpack_public_path__ + "assets/48158f6fac9202ec8de79b25bffbf52b.mp3";